import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { SocraticPracticeExperience } from '../components/SocraticPracticeExperience';

// Student entry point for the self-study socratic PRACTICE (Frente B). Non-graded
// dialogue against an approved standard's question bank + coaching at the end.
export function SocraticPracticePage(): JSX.Element {
  const { t } = useTranslation('sis');
  return (
    <Box sx={{ maxWidth: 820, mx: 'auto' }}>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        {t('socraticConsole.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t('socraticPractice.intro')}
      </Typography>
      <SocraticPracticeExperience />
    </Box>
  );
}
